// mypreset.ts
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#f8f4e8',
      100: '#f1e9d1',
      200: '#e3d3a4',
      300: '#d6bd77',
      400: '#cba660', // Main primary color
      500: '#b38e50',
      600: '#8d6f3e',
      700: '#66512c',
      800: '#40321a',
      900: '#1a1408',
    },
    secondary: {
      50: '#eaf6f8',
      100: '#cdeff2',
      200: '#99dfea',
      300: '#66cfe2',
      400: '#333333', // Main secondary color
      500: '#2b9eb3',
      600: '#217d8e',
      700: '#175c68',
      800: '#0d3b43',
      900: '#051b1d',
    },
    // success: {
    //     500: '#28a745', // Example success color
    // },
    // danger: {
    //     500: '#dc3545', // Example danger color
    // },
    // warning: {
    //     500: '#ffc107', // Example warning color
    // },
    // info: {
    //     500: '#17a2b8', // Example info color
    // },
  },
  colorScheme: {
    light: {
      primary: {
        color: '{primary.400}',
        contrastColor: '#ffffff',
        hoverColor: '{primary.800}',
        activeColor: '{primary.700}',
      },
      highlight: {
        background: '{primary.500}',
        focusBackground: '{primary.700}',
        color: '#ffffff',
        focusColor: '#ffffff',
      },
    },
    dark: {
      primary: {
        color: '{primary.50}',
        contrastColor: '{primary.950}',
        hoverColor: '{primary.200}',
        activeColor: '{primary.300}',
      },
      highlight: {
        background: '{primary.50}',
        focusBackground: '{primary.300}',
        color: '{primary.950}',
        focusColor: '{primary.950}',
      },
    },
    font: {
      family: 'Satoshi, sans-serif',
      size: '14px',
      weight: 'normal',
    },
  },
});

export default MyPreset;
